<template>
  <div>
    <v-container fluid>
      <v-card class="card--shadow">
        <patient-list :patients="patients" />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import PatientList from "@/components/patient/PatientList";

import { mapState } from "vuex";

export default {
  components: {
    PatientList,
  },
  computed: {
    ...mapState("Patient", ["patients"]),
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      // Build params object from all query parameters
      const params = {};
      
      // Copy all query parameters to params
      if (this.$route.query.page) params.page = this.$route.query.page;
      if (this.$route.query.search) params.search = this.$route.query.search;
      if (this.$route.query.township_id) params.township_id = this.$route.query.township_id;
      if (this.$route.query.support_type) params.support_type = this.$route.query.support_type;
      if (this.$route.query.support_startdate) params.support_startdate = this.$route.query.support_startdate;
      if (this.$route.query.support_enddate) params.support_enddate = this.$route.query.support_enddate;
      if (this.$route.query.mdrtb_reg_no) params.mdrtb_reg_no = this.$route.query.mdrtb_reg_no;
      if (this.$route.query.mdrtb_reg_year) params.mdrtb_reg_year = this.$route.query.mdrtb_reg_year;
      if (this.$route.query.nominated_month) params.nominated_month = this.$route.query.nominated_month;
      if (this.$route.query.nominated_year) params.nominated_year = this.$route.query.nominated_year;
      if (this.$route.query.nominated_support_type) params.nominated_support_type = this.$route.query.nominated_support_type;
      if (this.$route.query.onGoingEnddate) params.onGoingEndDate = this.$route.query.onGoingEnddate;
      if (this.$route.query.volunteer_id) params.volunteer_id = this.$route.query.volunteer_id;
      
      // Always include page, default to 1
      if (!params.page) params.page = 1;
      
      // Dispatch with all parameters
      this.$store.dispatch("Patient/getPatients", params);
    },
  },
  watch: {
    $route() {
      this.loadData();
    },
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
